import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

const fields = [
  ["ncm", "NCM", 8], ["cfop", "CFOP de venda", 4], ["csosn", "CSOSN", 3],
  ["origem", "Origem", 1], ["unidade", "Unidade", 6],
  ["pis", "CST PIS", 2], ["cofins", "CST COFINS", 2], ["cest", "CEST, se aplicável", 7],
];

export default function FiscalFields({ value, onChange }) {
  const fiscal = value || {};
  return (
    <fieldset className="space-y-3 border-t border-border pt-4">
      <legend className="text-sm font-medium pt-3">Cadastro fiscal</legend>
      <p className="text-xs text-muted-foreground">Confira o cadastro com a contabilidade. NCM, CFOP, CSOSN, origem e unidade são necessários. Na NFC-e, PIS e COFINS podem ficar em branco quando não exigidos para a operação.</p>
      <div className="grid grid-cols-2 gap-3">
        {fields.map(([key, label, maxLength]) => (
          <div key={key}>
            <Label htmlFor={`fiscal-${key}`} className="text-xs">{label}</Label>
            <Input id={`fiscal-${key}`} value={fiscal[key] || ""} maxLength={maxLength}
              onChange={e => onChange({ ...fiscal, [key]: e.target.value || undefined, validado: false })} />
          </div>
        ))}
      </div>
      <div className="flex items-start gap-2">
        <Checkbox id="fiscal-validado" checked={!!fiscal.validado}
          onCheckedChange={checked => onChange({ ...fiscal, validado: checked === true })} />
        <Label htmlFor="fiscal-validado" className="text-xs leading-relaxed">Confirmo que os códigos foram conferidos com a contabilidade.</Label>
      </div>
    </fieldset>
  );
}
